import { QRCodeSVG } from "qrcode.react";

interface QRCodeProps {
  uuid: string;
  size?: number;
}

export default function QRCode({ uuid, size = 200 }: QRCodeProps) {
  const url = `https://house-condo-expo.stardeck.site/lookup?id=${uuid}`;

  return (
    <div className="inline-flex flex-col items-center gap-2">
      <div className="rounded-lg border bg-white p-4">
        <QRCodeSVG
          value={url}
          size={size}
          level="M"
          includeMargin={false}
          aria-label={`QR Code for registration ${uuid}`}
        />
      </div>
    </div>
  );
}
